import React, { useEffect, useState } from "react";
import {
  Box,
  IconUpArrow,
  styled,
  themeGet,
} from "@catchoftheday/cg-components";

type ScrollToTopComponentProps = {
  isVisible: boolean;
};

const ScrollToTopComponent = styled(
  Box.withComponent("button")
)<ScrollToTopComponentProps>`
  width: 40px;
  height: 36px;
  position: fixed;
  padding: 0;
  bottom: 50px;
  right: 40px;
  z-index: 17;
  visibility: "visible";
  opacity: ${(props) => (props.isVisible ? 1 : 0)};
  border: 1px solid ${themeGet("colors.secondary")};
  border-radius: 5px;
  background-color: ${themeGet("colors.secondary")};
  transition: opacity 0.3s 0s, visibility 0s 0.3s;

  @media (max-width: ${themeGet("breakpoints.lg")}) {
    display: none;
  }
`;

export const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleVisibility = () => {
    if (window.pageYOffset > 244) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
  }, []);
  return (
    <ScrollToTopComponent
      isVisible={isVisible}
      aria-label="Scroll to Top"
      onClick={scrollToTop}
    >
      <IconUpArrow color="#FFF" />
    </ScrollToTopComponent>
  );
};
